/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCrown = createReactComponent("crown", "IconCrown", [
  ["path", { d: "M12 6l4 6l5 -4l-2 10h-14l-2 -10l5 4z", key: "svg-0" }]
]);

export { IconCrown as default };
//# sourceMappingURL=IconCrown.js.map
